import * as React from "react";
import { useState } from "react";
import { Alert } from "components/bootstrap";
import { DEFAULT_PAGE_SIZES } from "hooks/usePaginationQueryParameter";
import {
  GranteeListHeader,
  GranteeListStyledPageSizeSelect,
  GranteeListStyledPagination,
  GranteeListPaginationWrapper,
  StyledGranteeList
} from "components/permissions/CommonStyledComponents";
import GranteesListItem from "./GranteesListItem";
import CreateGranteesListItem from "./CreateGranteesListItem";
const _paginatedGrantees = (selectedGrantees, pageSize, currentPage) => {
  const begin = pageSize * (currentPage - 1);
  const end = begin + pageSize;
  return selectedGrantees.slice(begin, end);
};
const GranteesList = ({
  activeShares,
  onDelete,
  onCapabilityChange,
  entityType,
  entityTypeTitle = null,
  availableCapabilities,
  selectedGrantees,
  className = null,
  title,
  isCreating = false
}) => {
  const initialPageSize = DEFAULT_PAGE_SIZES[0];
  const [pageSize, setPageSize] = useState(initialPageSize);
  const [currentPage, setCurrentPage] = useState(1);
  const paginatedGrantees = _paginatedGrantees(selectedGrantees, pageSize, currentPage);
  const totalGrantees = selectedGrantees.size;
  const totalPages = Math.ceil(totalGrantees / pageSize);
  const showPageSizeSelect = totalGrantees > initialPageSize;
  const ItemComponent = isCreating ? CreateGranteesListItem : GranteesListItem;
  return /* @__PURE__ */ React.createElement("div", { className }, /* @__PURE__ */ React.createElement(GranteeListHeader, null, /* @__PURE__ */ React.createElement("h5", null, title), showPageSizeSelect && /* @__PURE__ */ React.createElement(GranteeListStyledPageSizeSelect, { onChange: (newPageSize) => setPageSize(newPageSize), pageSize })), paginatedGrantees.size > 0 ? /* @__PURE__ */ React.createElement(StyledGranteeList, null, paginatedGrantees.map((grantee) => {
    const currentGranteeState = grantee.currentState(activeShares);
    return /* @__PURE__ */ React.createElement(
      ItemComponent,
      {
        availableCapabilities,
        currentGranteeState,
        grantee,
        key: grantee.id,
        onDelete,
        onCapabilityChange
      }
    );
  }).toArray()) : /* @__PURE__ */ React.createElement(Alert, null, "This ", entityTypeTitle || entityType, " has no collaborators."), /* @__PURE__ */ React.createElement(GranteeListPaginationWrapper, null, /* @__PURE__ */ React.createElement(GranteeListStyledPagination, { totalPages, currentPage, onChange: setCurrentPage })));
};
export default GranteesList;
